<template>
  <article
    class="bq-card"
    :class="[
      `bq-card-${layout}`,
      `bq-card-${size}`,
      { 'bq-card-link': isLink },
      { mobile: isMobile },
    ]"
    @click="handleRouterPush(isLink, link)"
  >
    <!-- card 封面 -->
    <figure class="bq-card-cover" v-if="cover">
      <img :src="cover" alt="title" />
    </figure>

    <!-- card 封面插槽 -->
    <slot name="cover"></slot>

    <div
      class="bq-card-content"
      :class="{ link: isLink }"
      @click="handleRouterPush(isLink, link)"
    >
      <h3 v-if="title">{{ title }}</h3>

      <!-- 标签插槽 -->
      <slot name="tag"></slot>

      <!-- title 插槽 -->
      <slot name="title"></slot>

      <!-- 内容插槽 -->
      <slot name="content"></slot>

      <!-- 扩展插槽 -->
      <slot name="extra"></slot>
    </div>
  </article>
</template>

<script>
import { isWirelessDevice } from '../../../utils/utils';

export default {
  name: 'BQCard',

  props: {
    layout: {
      type: String,
      default: 'vertical', // horizontal || vertical
    },
    size: {
      type: String,
      default: '', // middle || large
    },
    cover: {
      type: String,
      required: true,
    },
    title: String,
    isLink: {
      type: Boolean,
      default: false,
    },
    link: String, // 内容区域的点击
  },

  data() {
    return {
      isMobile: false,
    };
  },

  created() {
    this.isMobile = isWirelessDevice();
  },

  methods: {
    handleRouterPush(isLink, path) {
      if (!isLink) {
        return;
      }

      // this.$router.push(path);
      location.href = path;
    },
  },
};
</script>

<style lang="less" scoped>
@import './index.less';
</style>
